import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Button,
  LinearProgress,
  Alert,
} from '@mui/material';
import {
  Analytics as AnalyticsIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  Timeline as TimelineIcon,
} from '@mui/icons-material';

const SapAnalytics: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1000);
  }, []);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          SAP Analytics
        </Typography>
        <Typography variant="body1" color="text.secondary">
          SAP system analysis and reports
        </Typography>
      </Box>

      {loading && <LinearProgress sx={{ mb: 2 }} />}
      
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={3}>
          <Card>
            <CardHeader
              avatar={<BarChartIcon color="primary" />}
              title="Sales Reports"
              titleTypographyProps={{ fontSize: '1rem' }}
            />
            <CardContent>
              <Typography variant="h4" color="primary">
                85%
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Growth vs previous month
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={6} lg={3}>
          <Card>
            <CardHeader
              avatar={<PieChartIcon color="secondary" />}
              title="User Distribution"
              titleTypographyProps={{ fontSize: '1rem' }}
            />
            <CardContent>
              <Typography variant="h4" color="secondary">
                1,250
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Active users
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={6} lg={3}>
          <Card>
            <CardHeader
              avatar={<TimelineIcon color="success" />}
              title="System Performance"
              titleTypographyProps={{ fontSize: '1rem' }}
            />
            <CardContent>
              <Typography variant="h4" color="success.main">
                99.8%
              </Typography>
              <Typography variant="body2" color="text.secondary">
                System uptime
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={6} lg={3}>
          <Card>
            <CardHeader
              avatar={<AnalyticsIcon color="warning" />}
              title="Transacciones"
              titleTypographyProps={{ fontSize: '1rem' }}
            />
            <CardContent>
              <Typography variant="h4" color="warning.main">
                45K
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Transactions per day
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SapAnalytics; 